import React from 'react';
import { Card, Tooltip } from 'antd';
import DateRange from '../filters/DateRange'


class ParcelRightPanelCard extends React.Component {

    handleInputChange = (key, e) => {
        console.log("DDDDDDDD", key, e)
    }

    render() {
        if (this.props.cardFor === 'parcel') {
            return (
                <div className="d-flex pb10">
                    <div className="col-md-6 pl5 pr5">
                        <Card>
                            <label>Classe</label>
                            <p className="card-design">{this.props.cardData.parcel && this.props.cardData.parcel.classe || 'nd'}</p>
                        </Card>
                    </div>
                    <div className="col-md-6 pr5 pl5">
                        <Card>
                            <label>Pontuação</label>
                            <p className="card-design">
                                {
                                    this.props.cardData.parcel && this.props.cardData.parcel.pontuacao &&
                                    (this.props.cardData.parcel.pontuacao+'').length > 6 ? 
                                    <Tooltip title={this.props.cardData.parcel.pontuacao} color={"#808080"}>
                                        {(this.props.cardData.parcel.pontuacao+'').substr(0,4)+'...'}
                                    </Tooltip> 
                                    : this.props.cardData.parcel.pontuacao || 'nd'
                                }
                            </p>
                        </Card>
                    </div>
                </div>
            )
        } else if (this.props.cardFor === 'vinica') {
            return (
                <div className="d-flex pb10">
                    <div className={this.props.id ? "col-md-6 pl5 pr5" : "col-md-12 pl5 pr5"}>
                        <Card>
                            <label>Franquia</label>
                            <p className="card-design">{this.props.leakage ? this.props.leakage.toFixed(3) : 0}%</p>
                        </Card>
                    </div>
                    {
                        this.props.id &&
                        <div className="col-md-6 pr5 pl5">
                            <Card>
                                <label>Vistoria</label>
                                <div className="row ">
                                    <div className="col-md-6">
                                        <p className="card-design">####</p>
                                    </div>
                                    
                                    <div className="col-md-4">
                                        <div className="ClaenderIcon">
                                        <DateRange
                                            inputOption={{ key: 'datePicker' }}
                                            handleInputChange={(key, value) => this.handleInputChange(key, value)} />

                                        </div>
                                    </div>

                                </div>


                            </Card>
                        </div>
                    }
                </div>
            )
        } else {
            return <div></div>
        }
    }
}


export default ParcelRightPanelCard;